

































helpers = require('../../helpers.coffee')

view_model = {
  data: () ->
    credentials:
      email: ''

    pristine: true
    apiErrorMessages: []
    emailRecovered: false

  methods:
    submit: ->
      @$validator.validateAll().then (success) =>
        @recoverPassword() if success

    recoverPassword: ->
      Loader.on()
      @clearApiErrors()
      new UsersResource().recoverPassword(@recoverSuccess, @recoverFailed, @credentials)

    recoverSuccess: ->
      Loader.off()
      @emailRecovered = true

    recoverFailed: (response) ->
      Loader.off()
      @handleApiErrors(response)

    addApiError: (message) ->
      @apiErrorMessages.push message

    clearApiErrors: ->
      @apiErrorMessages = []

    goToLogin: ->
      @emailRecovered = false
      @$router.push { name: 'landing' }

  mounted: () ->
    @errors.clear()
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/sessions/recover_password.vue